export default __webpack_public_path__ + "static/media/373.ef471604.png";